export const intercomMessageKeys: Record<
  'has_seen_certsy_assessments' | 'has_seen_verified_certsy_credentials',
  boolean
> = {
  has_seen_certsy_assessments: false,
  has_seen_verified_certsy_credentials: false,
};
